import { Button, Form, Image, Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import { jcTypeArray, validUrl } from "../../utils";
import { authenticateToken } from "../../utils/auth";
import { responseNotification } from "../../utils/notify";

const AddBrand = ({ visibleData, onCloseMethod }: any) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [brandData, setBrandData] = useState(undefined);
  const [logoUrl, setLogoUrl] = useState(undefined);

  const onSubmit = async (data: any) => {
    setLoading(true);

    const readyData = data && {
      name: data.name,
      logo: data.logo,
      type: data.type,
    };

    if (brandData) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/brand`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...readyData,
          id: brandData?.id,
          deleted: false,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Brand Updated Successfully", "success");
            form.resetFields();
            if (onCloseMethod) {
              onCloseMethod();
            }
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/brand`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(readyData),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Brand Create Successfully", "success");
            form.resetFields();
            if (onCloseMethod) {
              onCloseMethod();
            }
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  useEffect(() => {
    if (visibleData) {
      setBrandData(visibleData);
    }
  }, [visibleData]);

  useEffect(() => {
    if (brandData) {
      form.resetFields(Object.keys(visibleData));
      setLogoUrl(visibleData?.logo);
    }
  }, [brandData]);

  return (
    <div className="add-product drawer-toggle-wrapper">
      <div className="drawer-toggle-inner-wrapper">
        <Form
          name="control-hooks"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          className="ant-form ant-form-vertical"
          onFinish={onSubmit}
          form={form} // like ref
          layout="vertical"
          // requiredMark="optional"
          autoComplete="off"
          initialValues={{
            ...brandData,
          }}
        >
          <Form.Item
            hasFeedback
            label="Brand Name"
            rules={[
              {
                required: true,
                message: "Brand Title is Required!",
              },
            ]}
            name="name"
          >
            <Input id="name" type="text" placeholder="Enter Brand Name" />
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Type"
            rules={[
              {
                required: true,
                message: "Type is required!",
              },
            ]}
            name="type"
          >
            <Select placeholder="Shop Type" style={{ minWidth: 300 }}>
              {Object.values(jcTypeArray)?.map((type, i) => (
                <Select.Option value={type} key={i}>
                  {type?.replace("_", " ")}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Brand Logo"
            rules={[
              {
                required: true,
                message: "Brand Logo is required!",
              },
              {
                validator: async (_, value) => {
                  if (value && !validUrl(value)) {
                    return Promise.reject(new Error("Enter valid url"));
                  }
                },
              },
            ]}
            name="logo"
          >
            <Input
              id="logo"
              type="text"
              placeholder="Enter brand Logo"
              onChange={(e) => {
                setLogoUrl(e.target.value);
              }}
            />
          </Form.Item>

          {logoUrl && (
            <div className="mt-2" style={{ minWidth: "100%" }}>
              <Image src={logoUrl} height={150} className="img img-thumbnail" />
            </div>
          )}

          <div className="buttons-container">
            <Button
              disabled={loading}
              loading={(loading ? "loading" : undefined) as any}
              type="primary"
              htmlType="submit"
              className="add-submit-btn text-center mr-2"
            >
              Submit
            </Button>
            <Button
              type="ghost"
              htmlType="button"
              onClick={() => form?.resetFields()}
              className="reset-submit-btn text-center mr-2"
            >
              Reset
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AddBrand;
